import { useState } from "react";
import { toast } from "sonner";

import { authClient } from "@/lib/auth-client";
import { Button } from "@/components/ui/button";

/** Glifo de marca de Google. Lucide no trae iconos de marca, por eso va inline. */
function GoogleIcon() {
  return (
    <svg viewBox="0 0 48 48" className="size-[18px]" aria-hidden>
      <path
        fill="#EA4335"
        d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
      />
      <path
        fill="#4285F4"
        d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
      />
      <path
        fill="#FBBC05"
        d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
      />
      <path
        fill="#34A853"
        d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
      />
    </svg>
  );
}

/**
 * Botón de ingreso con Google, con el separador que lo despega del formulario
 * de correo que va debajo. Sirve igual en login y en registro: el backend crea
 * la cuenta si el correo no existe y la vincula si ya existía.
 */
export function GoogleSignInButton() {
  const [connecting, setConnecting] = useState(false);

  async function signInWithGoogle() {
    setConnecting(true);
    // Absolutas y del origen actual: better-auth valida ambas contra trustedOrigins,
    // y una ruta relativa se resolvería contra la API.
    const { error } = await authClient.signIn.social({
      provider: "google",
      callbackURL: `${window.location.origin}/dashboard`,
      errorCallbackURL: `${window.location.origin}/auth/login`,
    });
    // En el camino feliz el browser se va de la página, así que el botón se queda
    // deshabilitado a propósito: `/sign-in/*` solo admite 3 intentos cada 10s.
    if (error) {
      toast.error(error.message || "No pudimos conectar con Google");
      setConnecting(false);
    }
  }

  return (
    <>
      <div className="mt-8 flex flex-col">
        <Button
          type="button"
          variant="outline"
          onClick={signInWithGoogle}
          disabled={connecting}
          className="py-5"
        >
          <GoogleIcon />
          {connecting ? "Conectando..." : "Entrar con Google"}
        </Button>
      </div>
      <div className="mt-6 flex items-center gap-3">
        <span className="h-px flex-1 bg-slate-200 dark:bg-slate-700" />
        <span className="text-xs text-slate-400">o</span>
        <span className="h-px flex-1 bg-slate-200 dark:bg-slate-700" />
      </div>
    </>
  );
}
